// extracted by mini-css-extract-plugin
module.exports = {"container":"LockedSection_container__3JwBj","content":"LockedSection_content__2hNP6","text":"LockedSection_text__28nFv"};